import { DefaultPlayer, Player } from "./Player";

export const setNewUser = async (code: string | undefined, setUser: (newUser: Player) => void, mock = false) => {
    if (!code) return;

    const newUser = await FetchPlayerData(code, mock);
    if (newUser)
    {
        setUser(newUser);
    }
};

export async function FetchPlayerData(code: string, mock = false) {
    const endpoint = mock ? 'mockFetchUser' : 'fetchUser';
    const requestUrl = document.location.host.includes('localhost') ? `/${endpoint}/${code}` : `/${endpoint}/${code}`;
    try
    {
        const raw = await fetch(requestUrl);
        const data: any = await raw.json();
        console.log(data);
        if (data.error)
        {
            console.log(data.error);
            return null;
        }
        else
        {
            return data.data.getConnectCode.user;
        }
    }
    catch (e)
    {
        console.log('request failed: ', e);
        return null;
    }
}